// TurnoModal.jsx
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import "./TurnoModal.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faUser, faCalendarAlt, faTimesCircle, faClock } from '@fortawesome/free-regular-svg-icons';
import { faPlusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { apiRaw } from '../../api';
// Importar el ícono de historial de react-icons
import { AiOutlineHistory } from 'react-icons/ai';
import { FaUser, FaPhone, FaBuilding, FaBook, FaUserMd, FaDoorOpen, FaInfoCircle, FaEdit, FaSave, FaClock, FaComment, FaCalendarAlt } from 'react-icons/fa';
// Configurar moment.js para usar el idioma español
moment.locale('es'); // Establecer el idioma a español

const TAB_LIST = [
  { key: 'perfil', label: 'Perfil', icon: faUser, type: 'fa' },
  { key: 'citas', label: 'Citas', icon: faCalendarAlt, type: 'fa' },
  { key: 'historial', label: 'Historial', icon: AiOutlineHistory, type: 'react' },
  { key: 'comentarios', label: 'Comentarios', icon: faComment, type: 'fa' },
  { key: 'cancelar', label: 'Cancelar', icon: faTimesCircle, type: 'fa' },
];

const TurnoModal = ({
  isOpen,
  onClose,
  turnoSeleccionado,
  userRole,
  usuarioActualId,
  nombre,
  setNombre,
  telefono,
  setTelefono,
  motivoInactivo,
  setMotivoInactivo,
  nuevaFecha,
  setNuevaFecha,
  periodicidad,
  setPeriodicidad,
  nuevaHoraInicio,
  setNuevaHoraInicio,
  nuevaHoraFin,
  setNuevaHoraFin,
  nuevoComentario,
  setNuevoComentario,
  comentarioActualizado,
  cancelarActualizado,
  nuevoEstado,
  setNuevoEstado,
  categorias,
  categoriaSeleccionada,
  setCategoriaSeleccionada,
  servicioSeleccionado,
  setServicioSeleccionado,
  terapeutaSeleccionado,
  setTerapeutaSeleccionado,
  salaSeleccionada,
  setSalaSeleccionada,
  citasSeleccionadas,
  setCitasSeleccionadas,
  alertAsignarSala,
  handleUpdateText,
  handleUpdateDate,
  handleInsertComment,
  handleCancelar
}) => {

  const [salas, setSalas] = useState([]);
  const [salasDisponibles, setSalasDisponibles] = useState([]);
  const [listaTerapeutas, setListaTerapeutas] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [catalogoMotivosInactivo, setCatalogoMotivosInactivo] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [citasProgramadas, setCitasProgramadas] = useState([]);
  const [citasHistorial, setCitasHistorial] = useState([]);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [mostrarNuevaCita, setMostrarNuevaCita] = useState(false);
  const [nuevaCitaFecha, setNuevaCitaFecha] = useState('');
  const [nuevaCitaHoraInicio, setNuevaCitaHoraInicio] = useState('');
  const [nuevaCitaHoraFin, setNuevaCitaHoraFin] = useState('');
  const [nuevaCitaSala, setNuevaCitaSala] = useState('');
  const [nuevaCitaSalas, setNuevaCitaSalas] = useState([]);
  const [nuevaCitaSalasDisponibles, setNuevaCitaSalasDisponibles] = useState([]);
  const [nuevaCitaDisponible, setNuevaCitaDisponible] = useState(null);
  const [nuevaCitaChecking, setNuevaCitaChecking] = useState(false);
  const [nuevaCitaError, setNuevaCitaError] = useState('');

  // Estado para edición individual de cita
  const [citaEditando, setCitaEditando] = useState(null); // idTurno en edición
  const [citaEditandoValores, setCitaEditandoValores] = useState({ fecha: '', horaInicio: '', horaFin: '', idSala: '' });
  const [citaEditandoTodasSalas, setCitaEditandoTodasSalas] = useState([]);
  const [citaEditandoSalasDisponibles, setCitaEditandoSalasDisponibles] = useState([]);
  const [citaEditandoChecking, setCitaEditandoChecking] = useState(false);
  const [citaEditandoDisponible, setCitaEditandoDisponible] = useState(null);

  const [tab, setTab] = useState('perfil');
  const [btnEstado, setBtnEstado] = useState();
  const [btnFecha, setBtnFecha] = useState();

  const [nombreCategoria, setNombreCategoria] = useState();
  const [nombreServicio, setNombreServicio] = useState();
  const [nombreTerapeuta, setNombreTerapeuta] = useState();
  const [estado, setEstado] = useState();

  const horas = ["08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00"];

  const [selecciones, setSelecciones] = useState();

  const isDisabled = citasSeleccionadas.length === 0;

  // Filtrar tabs según el rol del usuario
  const getVisibleTabs = () => {
    if (userRole === 'secretaria') {
      return TAB_LIST.filter(tab => !['historial', 'comentarios'].includes(tab.key));
    }
    return TAB_LIST;
  };

  const obtenerServicios = async () => {
    return new Promise((resolve) => {
      setServicios([]);

      try {
        apiRaw(`/servicios/tienda/${categoriaSeleccionada}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar CESECOS',
                text: data.error,
              });
            } else {
              setServicios(data.servicios || []);
            }
            resolve();
          })
          .catch(error => {
            console.error('Error al cargar programas:', error);
            resolve();
          });
      } catch (error) {
        console.error('Error al obtener los progamas disponibles:', error);
        resolve();
      }
    });
  };

  const cargarTerapeutas = async () => {

    setListaTerapeutas([]);

    try {
      apiRaw(`/servicios/${servicioSeleccionado}/terapeutas`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {

          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar terapeutas',
              text: data.error,
            });
          } else {
            let lista = data || [];
            // Si el usuario logueado es terapeuta, solo puede verse a sí mismo
            if (userRole === 'terapeuta' && usuarioActualId) {
              lista = lista.filter(t => String(t.idUsuario) === String(usuarioActualId));
            }
            setListaTerapeutas(lista);
          }

        })
        .catch(error => console.error('Error al cargar terapeutas:', error));

    } catch (error) {
      console.error('Error al obtener terapeutas:', error);
    }


  };

  const getRolLabel = (rol) => {
    const rolMap = {
      'admin': 'Administrador',
      'direccion': 'Dirección',
      'coord_ceseco': 'Coordinador CESECO',
      'coord_programa': 'Coordinador Programa',
      'terapeuta': 'Terapeuta',
      'secretaria': 'Secretaria'
    };
    return rolMap[rol] || rol;
  };

  const obtenerComentarios = async () => {

    setComentarios([]);
    
    if (turnoSeleccionado.idPaciente != null) {
      try {
        apiRaw(`/pacientes/${turnoSeleccionado.idPaciente}/comentarios`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar comentarios',
                text: data.error,
              });
            } else {
              setComentarios(data.comentarios);
            }

          })
          .catch(error => console.error('Error al cargar comentarios:', error));

      } catch (error) {
        console.error('Error al obtener comentarios:', error);
      }
    }

  };

  const obtenerCitasProgramadas = async () => {
    return new Promise((resolve) => {
      setCitasProgramadas([]);

      if (turnoSeleccionado.idPaciente != null) {
        try {
          apiRaw(`/pacientes/${turnoSeleccionado.idPaciente}/turnos`, {
            method: 'GET',
          })
            .then(response => response.json())
            .then(data => {
              if (data.error) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al cargar las citas programadas',
                  text: data.error,
                });
              } else {
                const citasConDiasParseado = data.turnos.map((cita) => ({
                  ...cita,
                  dias: JSON.parse(cita.dias)
                }));
                setCitasProgramadas(citasConDiasParseado);
              }
              resolve();
            })
            .catch(error => {
              console.error('Error al cargar las citas programadas:', error);
              resolve();
            });
        } catch (error) {
          console.error('Error al obtener las citas programadas:', error);
          resolve();
        }
      } else {
        // Sin paciente asignado: mostrar el turno actual como única cita
        if (turnoSeleccionado?.dias) {
          try {
            const diasParseados = typeof turnoSeleccionado.dias === 'string'
              ? JSON.parse(turnoSeleccionado.dias)
              : turnoSeleccionado.dias;
            setCitasProgramadas([{ ...turnoSeleccionado, dias: diasParseados }]);
          } catch (e) {
            console.error('Error al parsear dias del turno:', e);
          }
        }
        resolve();
      }
    });
  };

  const obtenerCitasHistorial = async () => {

    setCitasHistorial([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        apiRaw(`/pacientes/${turnoSeleccionado.idPaciente}/turnos-historial`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar historial de citas',
                text: data.error,
              });
            } else {
              const citasConDiasParseado = data.turnos.map((cita) => ({
                ...cita,
                dias: JSON.parse(cita.dias)
              }));
              setCitasHistorial(citasConDiasParseado);
            }

          })
          .catch(error => console.error('Error al cargar historial de citas:', error));

      } catch (error) {
        console.error('Error al obtener historial de citas:', error);
      }
    }
  };

  const obtenerSalasDisponibles = async (idCategoriaParam = null, idTerapeutaParam = null) => {

    setSalas([]);
    setSalasDisponibles([]);

    // Usar los parámetros pasados o el estado actual
    const idCategoria = idCategoriaParam || categoriaSeleccionada;
    const idTerapeuta = idTerapeutaParam || terapeutaSeleccionado;

    if (turnoSeleccionado && idCategoria > 0 && turnoSeleccionado.dias && turnoSeleccionado.dias.length > 0 && idTerapeuta) {
      try {
        const { dia, horaInicio, horaFin } = turnoSeleccionado.dias[0];

        apiRaw(`/salas/disponibles?fecha=${dia}&horaInicio=${horaInicio}&horaFin=${horaFin}&idCategoria=${idCategoria}&idTerapeuta=${idTerapeuta}&idTurno=${turnoSeleccionado.idTurno}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              if (turnoSeleccionado.estado != 'Asignado') {
                Swal.fire({
                  icon: 'warning',
                  title: '',
                  text: data.error,
                });
              }
            } else {
              setSalas(data.salas || []);
              setSalasDisponibles(data.salasDisponibles || []);

            }

          })
          .catch(error => console.error('Error al cargar salas disponibles:', error));


      } catch (error) {
        console.error('Error al obtener las salas disponibles:', error);
      }
    }
  };

  const cargarCatalogos = () => {
    apiRaw(`/catalogos/motivos_inactivo`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMotivosInactivo(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo motivos_inactivo:', error));

  };

  const checkDatosCompletos = () => {
    if (nombre == '' || nombre == null) {
      Swal.fire('Atención!', 'Debes escribir el nombre del paciente', 'alert');
    } else if (telefono == '' || telefono == null) {
      Swal.fire('Atención!', 'Debes escribir el teléfono del paciente', 'alert');
    } else if (servicioSeleccionado == null || servicioSeleccionado == '') {
      Swal.fire('Atención!', 'Debes seleccionar un programa', 'alert');
    } else if (nuevoEstado == 'Asignado' && (terapeutaSeleccionado == null || terapeutaSeleccionado == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un terapeuta', 'alert');
    } else if (nuevoEstado == 'Asignado' && (salaSeleccionada == null || salaSeleccionada == '')) {
      Swal.fire('Atención!', 'Debes seleccionar una sala', 'alert');
    } else if ((nuevoEstado == 'Inactivo' || nuevoEstado == 'Finalizado') && (motivoInactivo == null || motivoInactivo == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un motivo', 'alert');
    } else {
      setBtnEstado('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateText(turnoSeleccionado.idTurno);

    }
  }

  const checkComentarioCompleto = (tipo) => {
    if (nuevoComentario == '' || nuevoComentario == null) {
      Swal.fire('Atención!', 'Debes escribir un comentario', 'alert');
    } else {
      handleInsertComment(turnoSeleccionado.idTurno, tipo);
    }
  }

  const checkDatosPrograma = () => {

    if (nuevaFecha == '' || nuevaFecha == null) {
      Swal.fire('Atención!', 'Debes seleccionar una fecha', 'alert');
    } else if (periodicidad == '' || periodicidad == null) {
      Swal.fire('Atención!', 'Debes seleccionar la periodicidad', 'alert');
    } else {
      setBtnFecha('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateDate(turnoSeleccionado.idTurno);
    }
  }

  const getUltimaFechaCita = () => {
    if (!citasProgramadas || citasProgramadas.length === 0) {
      return nuevaFecha;
    }

    const ordenadas = [...citasProgramadas].sort((a, b) => {
      const fechaA = a?.dias?.[0]?.dia || '';
      const fechaB = b?.dias?.[0]?.dia || '';
      return fechaA.localeCompare(fechaB);
    });

    return ordenadas[ordenadas.length - 1]?.dias?.[0]?.dia || nuevaFecha;
  };

  const calcularSiguienteFecha = (fechaBase) => {
    let siguienteFecha = moment(fechaBase);
    if (periodicidad === 'Quincenal') {
      siguienteFecha = siguienteFecha.add(14, 'days');
    } else {
      siguienteFecha = siguienteFecha.add(7, 'days');
    }
    return siguienteFecha.format('YYYY-MM-DD');
  };

  const handleAgregarUnaCita = () => {
    if ((citasProgramadas?.length || 0) >= 4) {
      return;
    }

    const fechaBase = getUltimaFechaCita();
    const siguiente = calcularSiguienteFecha(fechaBase);

    setNuevaCitaFecha(siguiente);
    setNuevaCitaHoraInicio(nuevaHoraInicio || '');
    setNuevaCitaHoraFin(nuevaHoraFin || '');
    setNuevaCitaSala(salaSeleccionada || '');
    setNuevaCitaError('');
    setNuevaCitaDisponible(null);
    setMostrarNuevaCita(true);
  };

  const handleCancelarNuevaCita = () => {
    setMostrarNuevaCita(false);
    setNuevaCitaFecha('');
    setNuevaCitaHoraInicio('');
    setNuevaCitaHoraFin('');
    setNuevaCitaSala('');
    setNuevaCitaSalas([]);
    setNuevaCitaSalasDisponibles([]);
    setNuevaCitaDisponible(null);
    setNuevaCitaChecking(false);
    setNuevaCitaError('');
  };

  const handleGuardarNuevaCita = async () => {
    if (!nuevaCitaFecha || !nuevaCitaHoraInicio || !nuevaCitaHoraFin) {
      Swal.fire('Atención!', 'Completa fecha y horario', 'alert');
      return;
    }

    if (!nuevaCitaSala) {
      Swal.fire('Atención!', 'Selecciona una sala', 'alert');
      return;
    }

    if (nuevaCitaDisponible === false) {
      Swal.fire('Atención!', 'La sala no está disponible en ese horario', 'warning');
      return;
    }

    if ((citasProgramadas?.length || 0) >= 4) {
      Swal.fire('Atención!', 'Ya hay 4 citas programadas', 'warning');
      return;
    }

    setNuevoComentario('');
    await handleInsertComment(turnoSeleccionado.idTurno, 4, {
      fecha: nuevaCitaFecha,
      horaInicio: nuevaCitaHoraInicio,
      horaFin: nuevaCitaHoraFin,
      idSala: nuevaCitaSala,
    });
    await obtenerCitasProgramadas();
    handleCancelarNuevaCita();
  };

  const cargarSalasDisponiblesNuevaCita = async () => {
    if (!nuevaCitaFecha || !nuevaCitaHoraInicio || !nuevaCitaHoraFin) {
      return;
    }

    if (!categoriaSeleccionada || !terapeutaSeleccionado) {
      setNuevaCitaError('Selecciona terapeuta y CESECO para validar sala');
      return;
    }

    setNuevaCitaChecking(true);
    setNuevaCitaError('');

    try {
      const idPaciente = turnoSeleccionado?.idPaciente || '';
      const response = await apiRaw(`/salas/disponibles?fecha=${nuevaCitaFecha}&horaInicio=${nuevaCitaHoraInicio}&horaFin=${nuevaCitaHoraFin}&idCategoria=${categoriaSeleccionada}&idTerapeuta=${terapeutaSeleccionado}&idTurno=${turnoSeleccionado.idTurno}&idPaciente=${idPaciente}`, {
        method: 'GET',
      });
      const data = await response.json();
      if (data.error) {
        setNuevaCitaError(data.error);
        setNuevaCitaSalas([]);
        setNuevaCitaSalasDisponibles([]);
        setNuevaCitaDisponible(null);
      } else {
        setNuevaCitaSalas(data.salas || []);
        setNuevaCitaSalasDisponibles(data.salasDisponibles || []);
      }
    } catch (error) {
      setNuevaCitaError('No se pudo validar la sala');
      setNuevaCitaSalas([]);
      setNuevaCitaSalasDisponibles([]);
      setNuevaCitaDisponible(null);
    } finally {
      setNuevaCitaChecking(false);
    }
  };

  useEffect(() => {
    if (!mostrarNuevaCita) {
      return;
    }

    cargarSalasDisponiblesNuevaCita();
  }, [mostrarNuevaCita, nuevaCitaFecha, nuevaCitaHoraInicio, nuevaCitaHoraFin, categoriaSeleccionada, terapeutaSeleccionado]);

  useEffect(() => {
    if (!mostrarNuevaCita || !nuevaCitaSala) {
      setNuevaCitaDisponible(null);
      return;
    }

    const disponible = nuevaCitaSalasDisponibles.some(s => String(s.idSala) === String(nuevaCitaSala));
    setNuevaCitaDisponible(disponible);
  }, [mostrarNuevaCita, nuevaCitaSala, nuevaCitaSalasDisponibles]);

  // ── Edición individual de cita ──────────────────────────────────────
  const handleEditarCita = (cita) => {
    if (turnoSeleccionado?.estado === 'Pendiente') {
      Swal.fire({
        icon: 'info',
        title: 'Cita pendiente de asignación',
        html: `<p style="color:#555; font-size:15px;">Para editar esta cita primero debes <strong>asignar el terapeuta y la sala</strong> desde la pestaña <strong>Perfil</strong>.<br><br>Una vez asignada, podrás ajustar fecha, hora y sala desde aquí.</p>`,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#14A7A3',
      });
      return;
    }
    setCitaEditando(cita.idTurno);
    setCitaEditandoValores({
      fecha: cita.dias[0].dia,
      horaInicio: cita.dias[0].horaInicio?.substring(0, 5) || '',
      horaFin: cita.dias[0].horaFin?.substring(0, 5) || '',
      idSala: cita.idSala || '',
    });
    setCitaEditandoTodasSalas([]);
    setCitaEditandoSalasDisponibles([]);
    setCitaEditandoDisponible(null);
    setCitaEditandoChecking(false);
    // Cerrar el formulario de nueva cita si estaba abierto
    setMostrarNuevaCita(false);
  };

  const handleCancelarEdicionCita = () => {
    setCitaEditando(null);
    setCitaEditandoValores({ fecha: '', horaInicio: '', horaFin: '', idSala: '' });
    setCitaEditandoTodasSalas([]);
    setCitaEditandoSalasDisponibles([]);
    setCitaEditandoDisponible(null);
    setCitaEditandoChecking(false);
  };

  const cargarSalasDisponiblesCitaEditando = async () => {
    const { fecha, horaInicio, horaFin } = citaEditandoValores;
    if (!fecha || !horaInicio || !horaFin || !categoriaSeleccionada || !terapeutaSeleccionado || !citaEditando) return;

    setCitaEditandoChecking(true);
    setCitaEditandoSalasDisponibles([]);
    setCitaEditandoDisponible(null);
    try {
      const idPaciente = turnoSeleccionado?.idPaciente || '';
      const res = await apiRaw(
        `/salas/disponibles?fecha=${fecha}&horaInicio=${horaInicio}&horaFin=${horaFin}&idCategoria=${categoriaSeleccionada}&idTerapeuta=${terapeutaSeleccionado}&idTurno=${citaEditando}&idPaciente=${idPaciente}`,
        { method: 'GET' }
      );
      const data = await res.json();
      if (!data.error) {
        setCitaEditandoTodasSalas(data.salas || []);
        setCitaEditandoSalasDisponibles(data.salasDisponibles || []);
      } else {
        // Limpiar disponibles para que no queden datos obsoletos del check anterior
        setCitaEditandoTodasSalas(data.salas || []);
        setCitaEditandoSalasDisponibles([]);
        setCitaEditandoDisponible(false);
      }
    } catch (e) {
      setCitaEditandoSalasDisponibles([]);
      setCitaEditandoDisponible(false);
      console.error('Error al verificar salas:', e);
    } finally {
      setCitaEditandoChecking(false);
    }
  };

  const handleGuardarEdicionCita = async () => {
    const { fecha, horaInicio, horaFin, idSala } = citaEditandoValores;

    if (!fecha || !horaInicio || !horaFin) {
      Swal.fire('Atención!', 'Completa fecha y horario', 'warning');
      return;
    }
    if (!idSala) {
      Swal.fire('Atención!', 'Selecciona una sala', 'warning');
      return;
    }
    if (citaEditandoDisponible === false) {
      Swal.fire('Atención!', 'La sala no está disponible en ese horario', 'warning');
      return;
    }

    try {
      const res = await apiRaw(`/turnos/${citaEditando}/reprogramar`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nuevaFecha: fecha, nuevaHoraInicio: horaInicio, nuevaHoraFin: horaFin, idSala, periodicidad }),
      });
      const data = await res.json();
      if (data.error) {
        Swal.fire('Error!', data.error, 'error');
      } else {
        Swal.fire('Actualización exitosa', data.mensaje, 'success');
        handleCancelarEdicionCita();
        await obtenerCitasProgramadas();
      }
    } catch (e) {
      Swal.fire('Error!', 'No se pudo actualizar la cita', 'error');
    }
  };

  // Recargar salas cuando cambia fecha/hora de la cita en edición
  useEffect(() => {
    if (!citaEditando) return;
    cargarSalasDisponiblesCitaEditando();
  }, [citaEditando, citaEditandoValores.fecha, citaEditandoValores.horaInicio, citaEditandoValores.horaFin]);

  // Actualizar disponibilidad cuando cambia la sala seleccionada
  useEffect(() => {
    if (!citaEditando || !citaEditandoValores.idSala) {
      setCitaEditandoDisponible(null);
      return;
    }
    const disponible = citaEditandoSalasDisponibles.some(s => String(s.idSala) === String(citaEditandoValores.idSala));
    setCitaEditandoDisponible(disponible);
  }, [citaEditando, citaEditandoValores.idSala, citaEditandoSalasDisponibles]);

  useEffect(() => {
    if (isOpen) {
      setIsLoadingModal(true);
      
      setNombre(turnoSeleccionado?.nombre || '');
      setTelefono(turnoSeleccionado?.telefono || '');

      setCategoriaSeleccionada(turnoSeleccionado?.idCategoriaSala || '');
      setServicioSeleccionado(turnoSeleccionado?.idServicio || '');
      setTerapeutaSeleccionado(turnoSeleccionado?.idTerapeuta || '');
      setSalaSeleccionada(turnoSeleccionado?.idSala || '');

      setNuevaFecha(turnoSeleccionado.dias[0].dia);
      setPeriodicidad(turnoSeleccionado.periodicidad);
      setNuevaHoraInicio(turnoSeleccionado.dias[0].horaInicio);
      setNuevaHoraFin(turnoSeleccionado.dias[0].horaFin);

      setNuevoEstado(turnoSeleccionado?.estado || '');

      setNombreCategoria(turnoSeleccionado?.nombreCategoria || '');
      // Buscar el nombre del servicio (programa) por idServicio en la lista de servicios
      let servicioNombre = '';
      if (turnoSeleccionado?.idServicio && Array.isArray(servicios) && servicios.length > 0) {
        const foundServicio = servicios.find(s => String(s.idServicio) === String(turnoSeleccionado.idServicio));
        if (foundServicio) {
          servicioNombre = foundServicio.titulo;
        }
      }
      setNombreServicio(servicioNombre || turnoSeleccionado?.servicio || '');
      setNombreTerapeuta(turnoSeleccionado?.nombreTerapeuta || '');
      setEstado(turnoSeleccionado?.estado || '');

      setBtnEstado('Editar');
      setBtnFecha('Editar')
      setTab('perfil');
      setSelecciones({ todas: false });
      setCitasSeleccionadas([]);
      handleCancelarNuevaCita();

      setNuevoComentario("");

      cargarCatalogos();
      // Para secretaria, no cargar comentarios ni historial (no tiene acceso a esos tabs)
      if (userRole !== 'secretaria') {
        obtenerComentarios();
        obtenerCitasHistorial();
      }
      
      // Cargar datos principales
      Promise.all([
        obtenerServicios(),
        obtenerCitasProgramadas()
      ]).then(() => {
        // Después de cargar datos, cargar salas con los valores del turno
        obtenerSalasDisponibles(turnoSeleccionado?.idCategoriaSala, turnoSeleccionado?.idTerapeuta);
        setIsLoadingModal(false);
      }).catch(error => {
        console.error('Error al cargar datos del modal:', error);
        setIsLoadingModal(false);
      });
    }

  }, [isOpen, turnoSeleccionado, userRole]);


  useEffect(() => {
    if (!isOpen) return;
    obtenerServicios();

  }, [isOpen, categoriaSeleccionada]);

  const handleCategoriaSeleccionada = (e) => {
    setCategoriaSeleccionada(e.target.value)
    setServicioSeleccionado(null);
    obtenerServicios();
  }

  useEffect(() => {
    if (!isOpen) return;
    cargarTerapeutas();
  }, [isOpen, servicioSeleccionado]);

  const handleServicioSeleccionado = (e) => {
    setServicioSeleccionado(e.target.value)
    setTerapeutaSeleccionado(null);
    cargarTerapeutas();
  }

  useEffect(() => {
    if (!isOpen) return;
    // Cargar salas cuando el terapeuta cambió
    obtenerSalasDisponibles();
  }, [isOpen, terapeutaSeleccionado]);

  useEffect(() => {
    if (isOpen && userRole !== 'secretaria') {
      obtenerComentarios();
    }
  }, [comentarioActualizado, isOpen, userRole]);

  useEffect(() => {
    if (isOpen) {
      obtenerCitasProgramadas();
    }
  }, [cancelarActualizado, isOpen]);


  const handleTerapeutaSeleccionado = (e) => {
    setTerapeutaSeleccionado(e.target.value)
    setSalaSeleccionada(null);
    obtenerSalasDisponibles();
  }


  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (value === "todas") {

      const todosIds = citasProgramadas.map(cita => cita.idTurno);
      setCitasSeleccionadas(todosIds);
      setSelecciones({ todas: checked });
    } else {

      const idCita = Number(value);
      let nuevasCitas = [...citasSeleccionadas];
      if (checked) {
        nuevasCitas.push(idCita);
      } else {
        nuevasCitas = nuevasCitas.filter((id) => id !== idCita);
      }

      setCitasSeleccionadas(nuevasCitas);
      setSelecciones({ todas: false });
    }
  };

  const citasOrdenadas = [...(citasProgramadas || [])].sort((a, b) => {
    const fechaA = a?.dias?.[0]?.dia || '';
    const fechaB = b?.dias?.[0]?.dia || '';
    return fechaA.localeCompare(fechaB);
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Detalle de la cita"
      ariaHideApp={false}
      className="modal-admin"
      overlayClassName="overlay-admin"
    >
      {/* LOADING SPINNER */}
      {isLoadingModal && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 1000,
          borderRadius: '8px'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem'
          }}>
            <div style={{
              width: '50px',
              height: '50px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #14a7a3',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <span style={{ color: '#666', fontWeight: '500' }}>Cargando información...</span>
          </div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}

      {/* CONTENIDO PRINCIPAL - Solo mostrar cuando se termina de cargar */}
      {!isLoadingModal && (
        <>
          {/* HEADER */}
          <div className='deFlexBtnsModal'>
            <div className='deFlexBtnsModal'>
              <div className="patientPhoto" />
              <div className="patientData">
                <h4>{turnoSeleccionado.nombre}</h4>
                <span>ID: {turnoSeleccionado.idTurno}</span>
              </div>
              <div className="bookStatus">
                <span>Estatus del paciente:</span>
                <span className="status">{estado}</span>
                <span className="motivo-inactivo">{turnoSeleccionado.motivo_inactivo}</span>
              </div>
            </div>
            <span className="close" onClick={onClose}>&times;</span>
          </div>

          {/* TABS SUPERIORES */}
          <div className="tabs">
        {getVisibleTabs().map(tabItem => (
          <button
            key={tabItem.key}
            className={`tab-label${tab === tabItem.key ? ' active' : ''}`}
            onClick={() => setTab(tabItem.key)}
          >
            {tabItem.type === 'fa' ? (
              <FontAwesomeIcon icon={tabItem.icon} style={{ marginRight: 8 }} />
            ) : (
              <tabItem.icon style={{ marginRight: 8, fontSize: 18, verticalAlign: 'middle' }} />
            )}
            {tabItem.label}
          </button>
        ))}
      </div>

      {/* CONTENIDO DE TABS */}
      <div className="tab-content">
        {/* PERFIL */}
        {tab === 'perfil' && (
          <div className="profile-card">
            {btnEstado === 'Editar' ? (
              <>
                <div className="profile-field">
                  <FaUser className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Nombre completo *</span>
                    <span className="profile-value">{nombre}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaPhone className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Teléfono de contacto *</span>
                    <span className="profile-value">{telefono}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBuilding className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Unidad CESECO *</span>
                    <span className="profile-value">{nombreCategoria}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBook className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Programa *</span>
                    <span className="profile-value">{nombreServicio}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaUserMd className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Terapeuta *</span>
                    <span className="profile-value">{nombreTerapeuta}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaDoorOpen className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Sala *</span>
                    <span className="profile-value">{salaSeleccionada ? salas.find(s => s.idSala == salaSeleccionada)?.nombre : ''}</span>
                  </div>
                </div>
                <div className="profile-field">
                  <FaInfoCircle className="profile-icon" />
                  <div style={{ flex: 1 }}>
                    <span className="profile-label">Estado *</span>
                    <span className="profile-value">{estado}</span>
                  </div>
                </div>
                {(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Motivo *</span>
                      <span className="profile-value">{motivoInactivo}</span>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="profile-field">
                  <FaUser className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Nombre completo *</span>
                    <span className="profile-input-icon"><FaUser /></span>
                    <input className="profile-input" type="text" value={nombre} onChange={e => setNombre(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaPhone className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Teléfono de contacto *</span>
                    <span className="profile-input-icon"><FaPhone /></span>
                    <input className="profile-input" type="text" value={telefono} onChange={e => setTelefono(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaBuilding className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Unidad CESECO *</span>
                    <span className="profile-input-icon"><FaBuilding /></span>
                    <select
                      className="profile-select"
                      value={categoriaSeleccionada || ""}
                      onChange={handleCategoriaSeleccionada}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar CESECO</option>
                      {categorias.map(c => (
                        <option key={c.idCategoria} value={c.idCategoria}>
                          {c.categoria}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBook className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Programa *</span>
                    <span className="profile-input-icon"><FaBook /></span>
                    <select
                      className="profile-select"
                      value={servicioSeleccionado || ""}
                      onChange={handleServicioSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar Programa</option>
                      {servicios.map(s => (
                        <option key={s.idServicio} value={s.idServicio}>
                          {s.titulo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaUserMd className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Asignar a *</span>
                    <span className="profile-input-icon"><FaUserMd /></span>
                    <select
                      className="profile-select"
                      value={terapeutaSeleccionado || ""}
                      onChange={handleTerapeutaSeleccionado}
                      required
                      disabled={userRole === 'secretaria'}
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar usuario</option>
                      {listaTerapeutas.map(t => {
                        const rolLabel = t.rol === 'terapeuta' ? 'Terapeuta' :
                                        t.rol === 'coord_programa' ? 'Coord. Programa' :
                                        t.rol === 'coord_ceseco' ? 'Coord. CESECO' : t.rol;
                        return (
                          <option key={t.idUsuario} value={t.idUsuario}>
                            {t.nombre} ({rolLabel})
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaDoorOpen className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Sala *</span>
                    <span className="profile-input-icon"><FaDoorOpen /></span>
                    <select
                      className="profile-select"
                      value={salaSeleccionada || ""}
                      onChange={e => setSalaSeleccionada(e.target.value)}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccione una sala</option>
                      {salas.map((s) => {
                        const estaDisponible = salasDisponibles.some(sd => sd.idSala === s.idSala);
                        return (
                          <option
                            key={s.idSala}
                            value={s.idSala}
                            disabled={!estaDisponible}
                          >
                            {s.nombre} {estaDisponible ? '' : '(No disponible)'}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaInfoCircle className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Estado *</span>
                    <span className="profile-input-icon"><FaInfoCircle /></span>
                    <select
                      className="profile-select"
                      value={nuevoEstado || ""}
                      onChange={e => setNuevoEstado(e.target.value)}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="Pendiente">Pendiente</option>
                      <option value="Asignado">Asignado</option>
                      <option value="Finalizado">Finalizado</option>
                      <option value="Inactivo">Inactivo</option>
                    </select>
                  </div>
                </div>
                {(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1, position: 'relative' }}>
                      <span className="profile-label">Motivo *</span>
                      <span className="profile-input-icon"><FaInfoCircle /></span>
                      <select
                        className="profile-select"
                        value={motivoInactivo || ""}
                        onChange={e => setMotivoInactivo(e.target.options[e.target.selectedIndex].text)}
                        required
                        style={{ paddingLeft: 38 }}
                      >
                        <option value="" disabled>Seleccione un motivo</option>
                        {catalogoMotivosInactivo.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="profile-save-btn-container">
              <button className="profile-edit-btn" onClick={() => {
                if (btnEstado === 'Editar') {
                  setBtnEstado('Guardar');
                } else {
                  checkDatosCompletos();
                }
              }}>
                {btnEstado === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                {btnEstado === 'Editar' ? 'Editar' : 'Guardar'}
              </button>
            </div>
          </div>
        )}

        {/* CITAS */}
        {tab === 'citas' && (
          <div className="card-section citas-modern">
            <div className="citas-header-row">
              <div className="citas-header-title">
                <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8, fontSize: 22 }} />
                <span style={{ fontWeight: 700, fontSize: 18 }}>Próximas citas</span>
              </div>
            </div>

            {citasOrdenadas.length > 0 ? (
              <div style={{ marginTop: 20 }}>
                {citasOrdenadas.map((cita, idx) => {
                  const esProxima = idx === 0;
                  const estaEditandoSerie = btnFecha !== 'Editar' && esProxima;
                  const estaEditandoIndividual = citaEditando === cita.idTurno;
                  const fechaMoment = moment(cita.dias[0].dia);
                  const diaSemana = fechaMoment.format('dddd');
                  const fechaFormateada = fechaMoment.format('D [de] MMMM [de] YYYY');

                  return (
                    <div key={cita.idTurno} style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 8,
                      padding: 16,
                      marginBottom: 12,
                      backgroundColor: estaEditandoSerie || estaEditandoIndividual ? '#f0f9ff' : '#fff'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 16, fontWeight: 600, color: '#333', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                            Cita {idx + 1}
                            {esProxima && (
                              <span style={{ fontSize: 11, backgroundColor: '#14a7a3', color: 'white', padding: '2px 10px', borderRadius: 12, fontWeight: 500 }}>
                                Próxima
                              </span>
                            )}
                          </div>

                          {/* Vista normal (sin edición) */}
                          {!estaEditandoSerie && !estaEditandoIndividual && (
                            <>
                              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8 }} />
                                <span style={{ fontSize: 14, color: '#555' }}>
                                  <b>{diaSemana}</b>, {fechaFormateada}
                                </span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <FontAwesomeIcon icon={faClock} style={{ color: '#14a7a3', marginRight: 8 }} />
                                <span style={{ fontSize: 14, color: '#555' }}>
                                  {cita.dias[0].horaInicio?.substring(0, 5)} - {cita.dias[0].horaFin?.substring(0, 5)} hrs
                                </span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FaDoorOpen style={{ color: '#14a7a3', marginRight: 8 }} />
                                <span style={{ fontSize: 14, color: '#555' }}>{cita.nombreSala || '—'}</span>
                              </div>
                            </>
                          )}

                          {/* Edición de serie (solo cita 1 - cambia periodicidad y recalcula serie) */}
                          {estaEditandoSerie && (
                            <div style={{ marginTop: 10 }}>
                              <div style={{ marginBottom: 12 }}>
                                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Fecha</label>
                                <input type="date" value={nuevaFecha} onChange={e => setNuevaFecha(e.target.value)}
                                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }} />
                              </div>
                              <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                                <div style={{ flex: 1 }}>
                                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Hora inicio</label>
                                  <input type="time" value={nuevaHoraInicio} onChange={e => setNuevaHoraInicio(e.target.value)}
                                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Hora fin</label>
                                  <input type="time" value={nuevaHoraFin} onChange={e => setNuevaHoraFin(e.target.value)}
                                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Periodicidad</label>
                                  <select value={periodicidad} onChange={e => setPeriodicidad(e.target.value)}
                                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }}>
                                    <option value="">Seleccione</option>
                                    <option value="Semanal">Semanal</option>
                                    <option value="Quincenal">Quincenal</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Edición individual de cita (independiente de la serie) */}
                          {estaEditandoIndividual && (
                            <div style={{ marginTop: 10 }}>
                              <div style={{ marginBottom: 12 }}>
                                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Fecha</label>
                                <input type="date" value={citaEditandoValores.fecha}
                                  onChange={e => setCitaEditandoValores(v => ({ ...v, fecha: e.target.value }))}
                                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }} />
                              </div>
                              <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                                <div style={{ flex: 1 }}>
                                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Hora inicio</label>
                                  <input type="time" value={citaEditandoValores.horaInicio}
                                    onChange={e => setCitaEditandoValores(v => ({ ...v, horaInicio: e.target.value }))}
                                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Hora fin</label>
                                  <input type="time" value={citaEditandoValores.horaFin}
                                    onChange={e => setCitaEditandoValores(v => ({ ...v, horaFin: e.target.value }))}
                                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }} />
                                </div>
                              </div>
                              <div style={{ marginBottom: 8 }}>
                                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Sala</label>
                                <select value={citaEditandoValores.idSala}
                                  onChange={e => setCitaEditandoValores(v => ({ ...v, idSala: e.target.value }))}
                                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }}>
                                  <option value="">Seleccione sala</option>
                                  {(citaEditandoTodasSalas.length > 0 ? citaEditandoTodasSalas : salas).map(sala => {
                                    const disponible = citaEditandoSalasDisponibles.some(sd => String(sd.idSala) === String(sala.idSala));
                                    return (
                                      <option key={sala.idSala} value={sala.idSala} disabled={!disponible}>
                                        {sala.nombre}{disponible ? '' : ' (No disponible)'}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                              {citaEditandoChecking ? (
                                <span style={{ fontSize: 12, color: '#888', fontStyle: 'italic' }}>Verificando disponibilidad...</span>
                              ) : citaEditandoDisponible === true ? (
                                <span style={{ fontSize: 12, color: '#388e3c', fontWeight: 600 }}>✓ Sala disponible</span>
                              ) : citaEditandoDisponible === false ? (
                                <span style={{ fontSize: 12, color: '#d32f2f', fontWeight: 600 }}>✗ Sala ocupada en ese horario</span>
                              ) : null}
                            </div>
                          )}
                        </div>

                        {/* Botones de acción */}
                        <div style={{ display: 'flex', flexDirection: 'row', gap: 8, marginLeft: 16, alignItems: 'flex-start' }}>
                          {/* Modo normal */}
                          {!estaEditandoSerie && !estaEditandoIndividual && (
                            <>
                              <button
                                onClick={() => handleEditarCita(cita)}
                                style={{
                                  padding: '8px 16px', backgroundColor: '#1976d2', color: 'white',
                                  border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                                  fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                                }}
                              >
                                <FaEdit /> Editar
                              </button>
                            </>
                          )}

                          {/* Modo edición de serie */}
                          {estaEditandoSerie && (
                            <>
                              <button
                                onClick={checkDatosPrograma}
                                style={{
                                  padding: '8px 16px', backgroundColor: '#388e3c', color: 'white',
                                  border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                                  fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                                }}
                              >
                                <FaSave /> Guardar
                              </button>
                              <button
                                onClick={() => {
                                  setBtnFecha('Editar');
                                  setNuevaFecha(turnoSeleccionado.dias[0].dia);
                                  setNuevaHoraInicio(turnoSeleccionado.dias[0].horaInicio);
                                  setNuevaHoraFin(turnoSeleccionado.dias[0].horaFin);
                                  setPeriodicidad(turnoSeleccionado.periodicidad);
                                }}
                                style={{
                                  padding: '8px 16px', backgroundColor: '#757575', color: 'white',
                                  border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                                  fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                                }}
                              >
                                Cancelar
                              </button>
                            </>
                          )}

                          {/* Modo edición individual */}
                          {estaEditandoIndividual && (
                            <>
                              <button
                                onClick={handleGuardarEdicionCita}
                                style={{
                                  padding: '8px 16px', backgroundColor: '#388e3c', color: 'white',
                                  border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                                  fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                                }}
                              >
                                <FaSave /> Guardar
                              </button>
                              <button
                                onClick={handleCancelarEdicionCita}
                                style={{
                                  padding: '8px 16px', backgroundColor: '#757575', color: 'white',
                                  border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                                  fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                                }}
                              >
                                Cancelar
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ color: '#999', fontSize: 14, marginTop: 20, padding: '12px 0' }}>
                No hay citas futuras programadas.
              </div>
            )}

            {!mostrarNuevaCita && (
              <button
                onClick={handleAgregarUnaCita}
                disabled={(citasProgramadas?.length || 0) >= 4}
                style={{
                  marginTop: 16, padding: '8px 18px', backgroundColor: (citasProgramadas?.length || 0) >= 4 ? '#ccc' : '#1976d2',
                  color: 'white', border: 'none', borderRadius: 4, cursor: (citasProgramadas?.length || 0) >= 4 ? 'not-allowed' : 'pointer',
                  fontSize: 14, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} />
                Agregar cita {(citasProgramadas?.length || 0) >= 4 ? '(máximo 4)' : `(${citasProgramadas?.length || 0}/4)`}
              </button>
            )}

            {mostrarNuevaCita && (
              <div style={{
                border: '1px dashed #aaa', borderRadius: 8, padding: 16, marginTop: 16, backgroundColor: '#f8f9fa'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#333', marginBottom: 10 }}>
                      Nueva cita
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Fecha</label>
                      <input
                        type="date"
                        value={nuevaCitaFecha}
                        onChange={e => setNuevaCitaFecha(e.target.value)}
                        style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }}
                      />
                    </div>
                    <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Hora inicio</label>
                        <input
                          type="time"
                          value={nuevaCitaHoraInicio}
                          onChange={e => setNuevaCitaHoraInicio(e.target.value)}
                          style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Hora fin</label>
                        <input
                          type="time"
                          value={nuevaCitaHoraFin}
                          onChange={e => setNuevaCitaHoraFin(e.target.value)}
                          style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>Sala</label>
                        <select
                          value={nuevaCitaSala}
                          onChange={e => setNuevaCitaSala(e.target.value)}
                          style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: 4, fontSize: 14 }}
                        >
                          <option value="">Seleccione</option>
                          {(nuevaCitaSalas.length > 0 ? nuevaCitaSalas : salas).map((sala) => {
                            const disponible = nuevaCitaSalasDisponibles.some(sd => String(sd.idSala) === String(sala.idSala));
                            return (
                              <option key={sala.idSala} value={sala.idSala} disabled={!disponible}>
                                {sala.nombre} {disponible ? '' : '(No disponible)'}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    {nuevaCitaChecking ? (
                      <span style={{ fontSize: 12, color: '#888', fontStyle: 'italic' }}>Validando disponibilidad...</span>
                    ) : nuevaCitaDisponible === true ? (
                      <span style={{ fontSize: 12, color: '#388e3c', fontWeight: 600 }}>✓ Sala disponible</span>
                    ) : nuevaCitaDisponible === false ? (
                      <span style={{ fontSize: 12, color: '#d32f2f', fontWeight: 600 }}>✗ Sala ocupada en ese horario</span>
                    ) : null}

                    {nuevaCitaError && (
                      <div style={{ color: '#d32f2f', fontSize: 13, marginTop: 8 }}>{nuevaCitaError}</div>
                    )}
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginLeft: 16 }}>
                    <button
                      onClick={handleGuardarNuevaCita}
                      style={{
                        padding: '8px 16px', backgroundColor: '#388e3c', color: 'white',
                        border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                        fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                      }}
                    >
                      <FaSave /> Guardar
                    </button>
                    <button
                      onClick={handleCancelarNuevaCita}
                      style={{
                        padding: '8px 16px', backgroundColor: '#757575', color: 'white',
                        border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14,
                        fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6
                      }}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* HISTORIAL */}
        {tab === 'historial' && (
          <div className="card-section">
            <div className="timeline">
              {citasHistorial.map((cita, i) => {
                const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                const diaSemana = diasSemana[fecha.getDay()];
                return (
                  <div className="timeline-event" key={cita.idTurno}>
                    <div className="timeline-dot" />
                    <div className="timeline-content">
                      <div><b>Sesión {i + 1}</b>: {diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</div>
                      <div><b>Estatus:</b> {cita.estado}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* COMENTARIOS */}
        {tab === 'comentarios' && (
          <>
            <div className="card-section comentarios-add-card">
              <fieldset className="comentarios-add-fieldset">
                <textarea
                  placeholder="Agregar comentario.."
                  value={nuevoComentario}
                  onChange={e => setNuevoComentario(e.target.value)}
                  id="comentario"
                  rows={3}
                  className="comentarios-add-textarea"
                />
              </fieldset>
              <div className="comentarios-btns-row">
                <button className="btnGrey" onClick={() => checkComentarioCompleto(1)}>
                  Guardar sólo el comentario
                </button>
                <button className="btnGreen" onClick={() => checkComentarioCompleto(2)}>
                  Dar de alta paciente
                </button>
              </div>
              <button className="btnBlue comentarios-btn-agendar" onClick={() => checkComentarioCompleto(3)}>
                Guardar comentario | Agendar 4 citas
              </button>
            </div>
            <div className="card-section comentarios-timeline">
              <div className="comentarios-timeline-list">
                {comentarios && comentarios.length > 0 ? (
                  [...comentarios].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)).map((c, idx) => (
                    <div className="comentario-timeline-item" key={c.idComentario}>
                      <div className="comentario-timeline-dot" />
                      <div className="comentario-timeline-content compact">
                        <div className="comentario-timeline-header">
                          <span className="comentario-timeline-user"><FaUser style={{ marginRight: 6 }} />{getRolLabel(c.rol)} - {c.nombre}</span>
                          <span className="comentario-timeline-date"><FaClock style={{ marginRight: 4 }} />{c.fecha}</span>
                        </div>
                        <div className="comentario-timeline-text">{c.comentario}</div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="comentarios-timeline-empty"><FaComment style={{ marginRight: 8 }} />No hay comentarios aún.</div>
                )}
              </div>
            </div>
          </>
        )}

        {/* CANCELAR */}
        {tab === 'cancelar' && (
          <div className="card-section cancel-section">
            <div className="cancel-list">
              {citasProgramadas && citasProgramadas.length > 0 ? (
                citasProgramadas.map((cita) => {
                  const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                  const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                  const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                  const diaSemana = diasSemana[fecha.getDay()];
                  return (
                    <div className="cancel-checkbox-row" key={cita.idTurno}>
                      <input
                        type="checkbox"
                        name="cita"
                        value={cita.idTurno}
                        checked={citasSeleccionadas.includes(cita.idTurno)}
                        onChange={handleCheckboxChange}
                        disabled={selecciones.todas}
                      />
                      <span>{diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</span>
                    </div>
                  );
                })
              ) : (
                <div>No hay próximas sesiones programadas.</div>
              )}
            </div>
            <button
              className="cancel-btn-fixed"
              onClick={() => {
                handleCancelar();
                setCitasSeleccionadas([]);
              }}
              disabled={isDisabled}
            >
              Cancelar seleccionadas
            </button>
          </div>
        )}
      </div>
        </>
      )}
    </Modal>
  );
};

export default TurnoModal;
